/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShiftiePlainDate } from './ShiftiePlainDate';
import {
    ShiftiePlainDateFromJSON,
    ShiftiePlainDateFromJSONTyped,
    ShiftiePlainDateToJSON,
    ShiftiePlainDateToJSONTyped,
} from './ShiftiePlainDate';

/**
 * Represents a Work Pattern Override for an Employee
 * @export
 * @interface WorkPatternOverride
 */
export interface WorkPatternOverride {
    /**
     * 
     * @type {number}
     * @memberof WorkPatternOverride
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof WorkPatternOverride
     */
    companyId: number;
    /**
     * 
     * @type {number}
     * @memberof WorkPatternOverride
     */
    employeeId: number;
    /**
     * 
     * @type {ShiftiePlainDate}
     * @memberof WorkPatternOverride
     */
    date: ShiftiePlainDate;
    /**
     * 
     * @type {boolean}
     * @memberof WorkPatternOverride
     */
    isWorkingDay: boolean;
}

/**
 * Check if a given object implements the WorkPatternOverride interface.
 */
export function instanceOfWorkPatternOverride(value: object): value is WorkPatternOverride {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('employeeId' in value) || value['employeeId'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('isWorkingDay' in value) || value['isWorkingDay'] === undefined) return false;
    return true;
}

export function WorkPatternOverrideFromJSON(json: any): WorkPatternOverride {
    return WorkPatternOverrideFromJSONTyped(json, false);
}

export function WorkPatternOverrideFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkPatternOverride {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'employeeId': json['employeeId'],
        'date': ShiftiePlainDateFromJSON(json['date']),
        'isWorkingDay': json['isWorkingDay'],
    };
}

  export function WorkPatternOverrideToJSON(json: any): WorkPatternOverride {
      return WorkPatternOverrideToJSONTyped(json, false);
  }

  export function WorkPatternOverrideToJSONTyped(value?: WorkPatternOverride | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'companyId': value['companyId'],
        'employeeId': value['employeeId'],
        'date': ShiftiePlainDateToJSON(value['date']),
        'isWorkingDay': value['isWorkingDay'],
    };
}

